(() => {
  if (window.nuvrendiRefreshInstalled) return;
  window.nuvrendiRefreshInstalled = true;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const animated = new WeakSet();
  const animations = new Set();
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;
      observer.unobserve(entry.target);
      if (reducedMotion.matches || window.Shopify?.designMode || !entry.target.animate) continue;
      const animation = entry.target.animate([
        { opacity: .75, transform: 'translateY(12px)' },
        { opacity: 1, transform: 'translateY(0)' }
      ], { duration: 420, easing: 'cubic-bezier(.2,.6,.3,1)' });
      animations.add(animation);
      animation.finished.then(() => animations.delete(animation)).catch(() => animations.delete(animation));
    }
  }, { threshold: .08 }) : null;
  function observeSections() {
    if (!observer) return;
    document.querySelectorAll('[data-nv-reveal]').forEach(element => {
      if (animated.has(element)) return;
      animated.add(element);
      observer.observe(element);
    });
  }
  function mountMobileSocial() {
    const template = document.getElementById('NuvrendiMobileSocial');
    if (!(template instanceof HTMLTemplateElement)) return;
    document.querySelectorAll('header-drawer .menu-drawer__navigation').forEach(navigation => {
      const drawer = navigation.closest('.menu-drawer');
      if (!drawer || drawer.querySelector('.nv-mobile-social')) return;
      navigation.after(template.content.cloneNode(true));
    });
  }
  function initialize() {
    mountMobileSocial();
    observeSections();
  }
  let pending = false;
  function scheduleMount() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => { pending = false; mountMobileSocial(); });
  }
  function start() {
    initialize();
    const header = document.getElementById('header-group');
    // The native header hydrates its drawer after first render; reinsert only our own links.
    if (header) new MutationObserver(scheduleMount).observe(header, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('shopify:section:load', () => {
    document.querySelectorAll('header-drawer .nv-mobile-social').forEach(element => element.remove());
    initialize();
  });
  reducedMotion.addEventListener('change', () => {
    if (reducedMotion.matches) animations.forEach(animation => animation.cancel());
  });
})();
